module.exports = __webpack_public_path__ + "public/img/bg-new-certif.be4c3152.png";